import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_87: FaireProductEntity = {
  token: "catalog_prod_prod-87",
  type: "product",
  name: "Decorative Item A - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 44.47,
  msrpDollars: 111.18,
  sku: "AN0087",
  caseSize: 3,
  material: "Linen",
  collectionToken: "col_andean-touch",
  categoryTokens: ["catalog_cat_makeup"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 158,
  description: "Beautiful Andean Touch piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
